import React from 'react';
import { Link } from 'react-router-dom';
import './ModernBlocks.css';

const CTABlock = ({ data }) => {
  return (
    <section 
      className="cta-section"
      style={{
        backgroundImage: data.background ? `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${data.background})` : 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)'
      }}
    >
      <div className="cta-container">
        <h2 className="cta-title">
          {data.title}
        </h2>
        <p className="cta-subtitle">
          {data.subtitle}
        </p>
        <div className="cta-buttons">
          {data.buttons.map((button, index) => (
            <Link
              key={index}
              to={button.link}
              className={`cta-button ${button.variant}`}
            >
              {button.text}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTABlock; 